import   React               ,  
       { useState            , 
	     useEffect           } from 'react';
		 
import   classNames            from 'classnames';

import   styles                from './ProductSheet_Price.module.scss';

import   Field                 from '../../widget/inputs/Field';
import   Select                from '../../widget/inputs/Select';
import   Toggle                from '../../widget/inputs/Toggle';
import   WidgetFrame           from '../../widget/navigation/WidgetFrame';
import   CollapsiblePanel      from '../../widget/windows/CollapsiblePanel';
import   Trigger               from '../../widget/actuators/Trigger';

import { ProductPrice        , 
         initializedPrice    , 
		 ProductDiscount     , 
		 initializedDiscount } from '../../../dataTypes/productManagment/types';

		 
		 
import ProductSheet_Price_Discount from './ProductSheet_Price_Discount';

export interface ProductSheet_Price_Props {
  price?    : ProductPrice;
  title     : string;
  width?    : string;
  onChange? : (newPrice: ProductPrice) => void;
  onResize? : () => void;
  onDelete? : () => void;
  open?     : boolean;
}

export const ProductSheet_Price = ({ price             ,
                                     title             ,
                                     width    = '100%' ,
                                     onChange          ,
                                     onResize          ,
                                     onDelete          ,
                                     open              }: ProductSheet_Price_Props) => {
  const isEditMode = !!price;
  const initialPrice = isEditMode ? price : initializedPrice();

  const [fields, setFields] = useState({
    id                : initialPrice.id ?? 0,
    name              : initialPrice.name ?? "p1",
    requiredStatus    : initialPrice.requiredStatus ?? "",
    comment           : initialPrice.comment ?? "",
    code              : initialPrice.code ?? "p1",
    active            : initialPrice.active,
    creationDate      : initialPrice.creationDate,
    basePrice         : initialPrice.basePrice ?? 0,
    taxRateChoice     : "Autre",
    taxRate           : initialPrice.taxRate ?? -1, // Utiliser -1 pour indiquer aucune TVA
    priceWithTax      : initialPrice.priceWithTax ?? 0,  // initialPrice.basePrice * (initialPrice.taxRate === -1 ? 1 : ( 1 + initialPrice.taxRate / 100 )),
    discountExistence : initialPrice.discounts ?  initialPrice.discounts.length > 0 : false,
    discounts         : initialPrice.discounts        ?? [],
 //   priceToPay        : initialPrice.priceToPay ?? 0,
  });

  const [, setMessages] = useState({
    name              : "",
    requiredStatus    : "",
    comment           : "",
    code              : "",
    active            : "",
    creationationDate : "",
    basePrice         : "",
    taxRate           : "",
    taxRateChoice     : "",
    priceWithTax      : "",
    discounts         : "",
 //   priceToPay        : "",
  });

  const [openDiscounts, setOpenDiscounts] = useState(() => {
    const initialOpenDiscounts: Record<number, boolean> = {};
    fields.discounts.forEach((_, index) => {
      initialOpenDiscounts[index] = true;
    });
    return initialOpenDiscounts;
  });


  const requiredStatusOptions = [
    "visitor",
    "registred",
    "standard",
    "premium",
  ];

  const requiredStatusLabels = [
    "Visiteur",
    "Inscrit",
    "Abonnement standard",
    "Abonnement premium",
  ];


  const taxRateOptions = [
    "0 %",
    "5,5 %",
    "10 %",
    "20 %",
    "Autre",
  ] as const;

  useEffect(() => {
	  
	console.log (price)   
	  
    let newTaxRateChoice: string = "Autre";

         if ( fields.taxRate ===  5.5 ) { newTaxRateChoice = "5,5 %"; }
    else if ( fields.taxRate === 10   ) { newTaxRateChoice = "10 %";  }
    else if ( fields.taxRate === 20   ) { newTaxRateChoice = "20 %";  }
    else if ( fields.taxRate ===  0   ) { newTaxRateChoice = "0 %";   }

    setFields( (prev) => {

      const updatedFields = { ...prev, taxRateChoice: newTaxRateChoice };

      notifyPriceChange({ ...initialPrice, ...updatedFields });

      return updatedFields;
    });

  }, []);


  const handleActiveChange = (newValue: boolean ) => {

    setFields( (prev) => {

      const updatedFields = { ...prev, active: newValue };

      notifyPriceChange({ ...initialPrice, ...updatedFields });

      return updatedFields;
    });
  }


  const handleRequiredStatusChange = (e: React.ChangeEvent<HTMLSelectElement>) => {

    const newValue = e.target.value;

    setFields( (prev) => {

      const updatedFields = { ...prev, requiredStatus: newValue };

      notifyPriceChange({ ...initialPrice, ...updatedFields });

      return updatedFields;
    });
  };


  const handleCommentChange = (e: React.ChangeEvent<HTMLInputElement>) => {

    const newValue = e.target.value;

    setFields( (prev) => {

      const updatedFields = { ...prev, comment: newValue };

      notifyPriceChange({ ...initialPrice, ...updatedFields });

      return updatedFields;
    });
  };

  const handleTaxRateChoiceChange = (e: React.ChangeEvent<HTMLSelectElement>) => {

    const rawValue = e.target.value;

    let newTaxRate = -1; // Utiliser -1 pour indiquer aucune TVA

         if (rawValue === '20 %' ) { newTaxRate = 20;  }
    else if (rawValue === '10 %' ) { newTaxRate = 10;  }
    else if (rawValue === '5,5 %') { newTaxRate = 5.5; }
    else if (rawValue === '0 %'  ) { newTaxRate = 0;   }

    let newPriceWithTax = newTaxRate === -1
      ? fields.basePrice
      : fields.basePrice * (1 + newTaxRate / 100);

	//newPriceWithTax = Math.round(newPriceWithTax * 100) / 100


    setFields( (prev) => {

      const updatedFields = { ...prev, taxRate: newTaxRate, priceWithTax: newPriceWithTax, taxRateChoice: rawValue };

      notifyPriceChange({ ...initialPrice, ...updatedFields });

      return updatedFields;
    });
  };

  const handleBasePriceChange = (e: React.ChangeEvent<HTMLInputElement>, parsedValue: string | number | File | Date) => {

    const newBasePrice = parsedValue as number

    if ( newBasePrice < 0)
     {
      setMessages((prev) => ({
        ...prev,
        basePrice: "Le prix de base doit être un nombre positif.",
      }));
      return;
     }

    setMessages((prev) => ({
      ...prev,
      basePrice: "",
    }));

    let newPriceWithTax = fields.taxRate === -1
      ? newBasePrice
      : newBasePrice * (1 + fields.taxRate / 100);

	//newPriceWithTax = Math.round(newPriceWithTax * 100) / 100


    setFields( (prev) => {

      const updatedFields = { ...prev,  basePrice: newBasePrice, priceWithTax: newPriceWithTax, };

      notifyPriceChange({ ...initialPrice, ...updatedFields });

      return updatedFields;
    });
  };

  const handlePriceWithTaxChange = (e: React.ChangeEvent<HTMLInputElement>, parsedValue: string | number | File | Date) => {

    const newPriceWithTax = parsedValue as number

    if (newPriceWithTax < 0)
     {
      setMessages((prev) => ({
        ...prev,
        priceWithTax: "Le prix TTC doit être un nombre positif.",
      }));
      return;
     }

    setMessages((prev) => ({
      ...prev,
      priceWithTax: "",
    }));

    let newBasePrice = fields.taxRate === -1
      ? newPriceWithTax
      : newPriceWithTax / (1 + fields.taxRate / 100);

	//newBasePrice = Math.round(newBasePrice * 100) / 100

    setFields( (prev) => {

      const updatedFields = { ...prev,  basePrice: newBasePrice, priceWithTax: newPriceWithTax, };

      notifyPriceChange({ ...initialPrice, ...updatedFields });

      return updatedFields;
    });
  };

  //////////////////////////////



  const handleTaxRateChange = (e: React.ChangeEvent<HTMLInputElement>, parsedValue: string | number | File | Date) => {

    const newTaxRate = parsedValue as number;

    if (isNaN(newTaxRate) || newTaxRate < -1) { // Permettre -1 pour indiquer aucune TVA
      setMessages((prev) => ({
        ...prev,
        taxRate: "Le taux de TVA doit être un nombre valide.",
      }));
      return;
    }

    setMessages((prev) => ({
      ...prev,
      taxRate: "",
    }));

    let newPriceWithTax = newTaxRate === -1
      ? fields.basePrice
      : fields.basePrice * (1 + newTaxRate / 100);

	//newPriceWithTax = Math.round(newPriceWithTax * 100) / 100


    setFields( (prev) => {

      const updatedFields = { ...prev,  taxRate: newTaxRate, priceWithTax: newPriceWithTax };

      notifyPriceChange({ ...initialPrice, ...updatedFields });

      return updatedFields;
    });
  };

  const handleDiscountExistanceChange = (newValue: boolean) => {

    setFields( (prev) => {

      const updatedFields = { ...prev,  discountExistence: newValue };

      notifyPriceChange({ ...initialPrice, ...updatedFields });

      if (newValue && fields.discounts.length === 0 )
       {
        handleAddDiscount();
       }

      return updatedFields;
    });
  };

  const handleAddDiscount = () => {

    setFields( (prev) => {

      const updatedDiscounts = [...prev.discounts, initializedDiscount()];

      const updatedFields = { ...prev,  discounts: updatedDiscounts };

      setOpenDiscounts((prev) => ({ ...prev, [fields.discounts.length]: true }));

      notifyPriceChange({ ...initialPrice, ...updatedFields });

      return updatedFields;
    });
  }

  const handleDeleteDiscount = (index: number) => {

    setFields( (prev) => {

      const updatedDiscounts = prev.discounts.filter((_, i) => i !== index);

      const updatedFields = { ...prev,  discounts: updatedDiscounts };

      notifyPriceChange({ ...initialPrice, ...updatedFields });

      return updatedFields;
    });
  }

  const handleDiscountChange = (updatedDiscount: ProductDiscount, discountIndex: number) => {

    setFields( (prev) => {

      const updatedDiscounts = [...prev.discounts];

      updatedDiscounts[discountIndex] = updatedDiscount;

      const updatedFields = { ...prev,  discounts: updatedDiscounts };

      notifyPriceChange({ ...initialPrice, ...updatedFields });

      return updatedFields;
    });

  };

  const notifyPriceChange = (newPrice: ProductPrice) => {

    if (onChange)
     {
      onChange(newPrice);
     }
  };

  return (
    <div className={classNames(styles.root)}>
      <CollapsiblePanel title={title} onResize={onResize} onDelete={onDelete} open={open}>
        <div className={classNames(styles.contain)}>
          <div className={classNames(styles.active)}>
            <WidgetFrame name              = "Actif :"
                         labelTextPosition = "right"
                         classNameGrid     = {classNames(styles.grid_frame)} >
              <Toggle checked  = {fields.active}
                      onChange = {handleActiveChange}
                      form     = "switch" />
            </WidgetFrame>
          </div>

          {/*
          <div className={classNames(styles.code)}>
            <WidgetFrame name              = "Réf produit :"
                         labelTextPosition = "right"
                         classNameGrid     = {classNames(styles.grid_frame2)} >
              <Field type     = "text"
                     value    = {fields.code}
                     onChange = {handleCodeChange} />
            </WidgetFrame>
          </div>
          */}

          <div className={classNames(styles.requiredStatus)}>
            <WidgetFrame name              = "Cible client :"
                         labelTextPosition = "right"
                         classNameGrid     = {classNames(styles.grid_frame2)} >
              <Select choices      = {requiredStatusOptions}
                      choicesLabel = {requiredStatusLabels}
                      value        = {fields.requiredStatus}
                      onChange     = {handleRequiredStatusChange} />
            </WidgetFrame>
          </div>

          {/*
          <div className={classNames(styles.name)}>
            <WidgetFrame name              = "Nom :"
                         labelTextPosition = "right"
                         classNameGrid     = {classNames(styles.grid_frame)} >
              <Field type     = "text"
                     value    = {fields.name}
                     onChange = {handleNameChange} />
            </WidgetFrame>
          </div>
          */}

          <div className={classNames(styles.comment)}>
            <WidgetFrame name              = "Description :"
                         labelTextPosition = "right"
                         classNameGrid     = {classNames(styles.grid_frame2)} >
              <Field type     = "text"
                     value    = {fields.comment}
                     onChange = {handleCommentChange}/>						 
            </WidgetFrame>
          </div>

          <div className={classNames(styles.basePrice)}>
            <WidgetFrame name              = "Prix hors-taxe :"
                         labelTextPosition = "right"
                         classNameGrid     = {classNames(styles.grid_frame)} >
              <div className={classNames(styles.oneLineDisplay)}>
              <Field type     = "number"
                     value    = {fields.basePrice}
                     onChange = {handleBasePriceChange}
					 decimalPlaces = {2}
                     width    = "100px" />
              &nbsp;
              €
              </div>
            </WidgetFrame>
          </div>

          <div className={classNames(styles.taxRate)}>
            <WidgetFrame name              = "TVA :"
                         labelTextPosition = "right"
                         classNameGrid     = {classNames(styles.grid_frame2)} >
             <div className={classNames(styles.oneLineDisplay)}>

              <Select choices  = {[...taxRateOptions]}
                      value    = {fields.taxRateChoice}
                      onChange = {handleTaxRateChoiceChange} />
              {
               fields.taxRateChoice === "Autre" &&
               (
                <>
                 &nbsp;&nbsp;Valeur :&nbsp;
                 <Field type     = "number"
                        value    = {fields.taxRate === -1 ? '' : fields.taxRate}
                        onChange = {handleTaxRateChange}
					 decimalPlaces = {2}
                        width    = "100px" />
                 &nbsp;
                 %
                </>
               )
              }
             </div>
            </WidgetFrame>
          </div>

          <div className={classNames(styles.priceWithTax)}>
            <WidgetFrame name              = "Prix TTC :"
                         labelTextPosition = "right"
                         classNameGrid     = {classNames(styles.grid_frame2)} >
             <div className={classNames(styles.oneLineDisplay)}>
              <Field type     = "number"
                     value    = {fields.priceWithTax}
                     onChange = {handlePriceWithTaxChange}
					 decimalPlaces = {2}
                     width    = "100px" />
              &nbsp;
              €
              </div>
            </WidgetFrame>
          </div>

          <div className={classNames(styles.discountsExistence)}>
            <WidgetFrame name              = "Remises :"
                         labelTextPosition = "right"
                         classNameGrid     = {classNames(styles.grid_frame)} >
              <Toggle checked  = {fields.discountExistence}
                      onChange = {handleDiscountExistanceChange}
                      form     = "switch" />

            </WidgetFrame>
          </div>

        {
         fields.discountExistence &&
         (
          <div className={classNames(styles.discountsList)}>

              <div className={classNames(styles.bloc)}>
                {
                  fields.discounts.map ((discount, index) => (
                  <div key       = {index}
                       className = {classNames(styles.panelWrapper)}>
                    <ProductSheet_Price_Discount key      = {index}
					                             price    = {fields}
                                                 discount = {discount}
                                                 title    = {`Remise n°${index + 1}`}
                                                 onChange = {(d) => handleDiscountChange(d, index)}
                                                 onDelete = {() => handleDeleteDiscount(index)}
                                                 open     = {openDiscounts[index] ?? undefined} />
                  </div>
                 ))
                }
                <Trigger name    = "Ajouter une remise"
                         onClick = {handleAddDiscount}
                         variant = "tailwind2"
                />
              </div>
          </div>
         )
        }

        {/*
          <div className={classNames(styles.priceToPay)}>
            <WidgetFrame name              = "Prix avec remises :"
                         labelTextPosition = "right"
                         classNameGrid     = {classNames(styles.grid_frame)} >
              <div className={classNames(styles.oneLineDisplay)}>

              <Label value={fields.priceToPay.toFixed(2)} />
              &nbsp;
              €
              </div>
            </WidgetFrame>
          </div>
        */}
		
        </div>
      </CollapsiblePanel>
    </div>
  );
};

export default ProductSheet_Price;
